export default __webpack_public_path__ + "static/mailchimp-hero-img-f0a392b900b69b25a3f0728fc0f03f0a.webp";